    export const FooterStyles = {
        marginTop: "auto",
        backgroundColor: "#d1d4d3",
        color: "black"
    }
    export const FooterItemsStyles = {
        display: "flex",
        justifyContent: "space-between"
    }
    export const AlertStyles = {
        borderRadius: "40px",
        backgroundColor: "#f44336",
        color: "#fff",
        boxShadow:
            "0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%)"
    }
    export const AlertTextStyles = {
        fontSize: "16px",
        color: "#131215",
        margin: (theme) => theme.spacing(0.5, 3)
    }
    export const AlertTitleStyles = {
        fontSize: "16px",
        color: "#131215",
        fontWeight: "bold",
        margin: (theme) => theme.spacing(0.5, 3)
    }
    export const LowerCaseButtonRightStyles = {
        textTransform: "none",
        backgroundColor: "#fff",
        color: "#131215",
        borderRadius: "5px",
        marginTop: (theme) => theme.spacing(1.5),
        marginLeft: (theme) => theme.spacing(1)
    }
    export const LowerCaseButtonLeftStyles = {
        textTransform: "none",
        backgroundColor: "#fff",
        color: "#131215",
        borderRadius: "5px",
        marginTop: (theme) => theme.spacing(1.5)
    }
